module.exports = __webpack_public_path__ + "static/media/features-share-image.88abdcf2.jpg";